import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const MenuService = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 48 48">
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24" r="24" fill="#F5E4E7"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M13 13.75C13 12.2312 14.2312 11 15.75 11H31.75C33.2688 11 34.5 12.2312 34.5 13.75V33.75C34.5 35.2688 33.2688 36.5 31.75 36.5H15.75C14.2312 36.5 13 35.2688 13 33.75V13.75Z" fill="#C72037"/>
      <path d="M17.75 17.5C17.75 17.0858 18.0858 16.75 18.5 16.75H27C27.4142 16.75 27.75 17.0858 27.75 17.5C27.75 17.9142 27.4142 18.25 27 18.25H18.5C18.0858 18.25 17.75 17.9142 17.75 17.5Z" fill="#FDFDFD"/>
      <path d="M17.75 23.5C17.75 23.0858 18.0858 22.75 18.5 22.75H23C23.4142 22.75 23.75 23.0858 23.75 23.5C23.75 23.9142 23.4142 24.25 23 24.25H18.5C18.0858 24.25 17.75 23.9142 17.75 23.5Z" fill="#FDFDFD"/>
      <path d="M17.75 29.5C17.75 29.0858 18.0858 28.75 18.5 28.75H29C29.4142 28.75 29.75 29.0858 29.75 29.5C29.75 29.9142 29.4142 30.25 29 30.25H18.5C18.0858 30.25 17.75 29.9142 17.75 29.5Z" fill="#FDFDFD"/>
      </svg>
    </SvgIcon>
  );
}

export default MenuService;